/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeDomains.vue?vue&type=template&id=d24b828e&scoped=true&"
import script from "./themeDomains.vue?vue&type=script&lang=js&"
export * from "./themeDomains.vue?vue&type=script&lang=js&"
import style0 from "./themeDomains.vue?vue&type=style&index=0&id=d24b828e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b828e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VProgressCircular,VSimpleTable,VTextField})
